import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { CreateNgwGamePage } from '../CreateNgwGame/CreateNgwGame';
import { TabsPage } from '../tabs/tabs';
import { PastGames } from '../pastGames/pastGames';
import { NgwService } from '../../app/ngw.service';

/**
 * Generated class for the Home page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  templateUrl: 'home.html'
})
export class Home {
  
  constructor(public navCtrl: NavController, public navParams: NavParams,  private ngwService: NgwService) {
  }

  openCreatePage() {
    this.navCtrl.setRoot(CreateNgwGamePage);
  }

  openCurrentGamePage() {
    if(this.ngwService.currentGame)
      this.navCtrl.setRoot(TabsPage);
  }
  
  ionViewDidLoad() {
    
  }

  openPastGamesPage() {
    this.navCtrl.push(PastGames);
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts